import { handleStarRatingInvalid } from './star-rating/handle-star-rating-invalid';
import { isStarRatingValid } from './star-rating/is-star-rating-valid';
import { FormWidget } from '../../form-widget';

export type FormNotValidReason = 'rating' | string; /*                                   */

export type CheckAndHandleValidityReturn = { valid: true } | { valid: false; reason: FormNotValidReason };

export type CheckAndHandleValidityParams = {
    rootElement: Pick<HTMLElement, 'querySelector' | 'querySelectorAll'>;
    formWidgets: FormWidget[];
};
export const checkAndHandleValidity = async ({
    rootElement,
    formWidgets,
}: CheckAndHandleValidityParams): Promise<CheckAndHandleValidityReturn> => {
    const reasons: string[] = [];
    let isFirstError = true;
    if (!(await isStarRatingValid({ rootElement }))) {
        handleStarRatingInvalid({ rootElement });
        isFirstError = false;
        reasons.push('rating');
    }
    for (const formWidget of formWidgets) {
        if (!formWidget.isFormValid()) {
            if (isFirstError) {
                formWidget.scrollIntoErrorView();
            }
            isFirstError = false;
            reasons.push(formWidget.getName());
        }
    }

    /*                             */
    if (reasons.length > 0) {
        return { valid: false, reason: reasons.join(', ') };
    }
    return { valid: true };
};
